import React from 'react';
import axios from 'axios';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import TeilnehmerLogin from './pages/TeilnehmerLogin';
import TeilnehmerDashboard from './pages/TeilnehmerDashboard';
import AdminLogin from './pages/AdminLogin';
import AdminSetup from './pages/AdminSetup';
import AdminLayout from './layouts/AdminLayout';
import AdminDashboard from './pages/AdminDashboard';
import TeilnehmerTab from './components/admin/TeilnehmerTab';
import TextbausteineTab from './components/admin/TextbausteineTab';
import KursdetailsPage from './pages/admin/KursdetailsPage';
import SystemPage from './pages/admin/SystemPage';
import FeldmappingPage from './pages/admin/FeldmappingPage';
import TextePage from './pages/admin/TextePage';
import BenutzerPage from './pages/admin/BenutzerPage';
import KursfarbenPage from './pages/admin/KursfarbenPage';
import PasswortPage from './pages/admin/PasswortPage';
import { Toaster } from './components/ui/sonner';
import './App.css';

// Global Axios interceptor to prevent caching
axios.interceptors.request.use((config) => {
  config.headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
  config.headers['Pragma'] = 'no-cache';
  config.headers['Expires'] = '0';
  // Add timestamp to prevent caching
  config.params = { ...config.params, _t: Date.now() };
  return config;
});

// Response interceptor to handle auth errors
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    // If we get a 401 on an admin route, clear token and redirect
    if (error.response?.status === 401) {
      const isAdminRoute = window.location.pathname.startsWith('/admin');
      const isAdminRequest = error.config?.url?.includes('/admin/');
      
      if (isAdminRoute || isAdminRequest) {
        localStorage.removeItem('admin_token');
        // Only redirect if not already on login page
        if (!window.location.pathname.includes('/login')) {
          window.location.href = '/admin/login';
        }
      }
      
      // Handle teilnehmer 401
      const isTeilnehmerRoute = window.location.pathname.startsWith('/teilnehmer');
      const isTeilnehmerRequest = error.config?.url?.includes('/teilnehmer/');
      
      if ((isTeilnehmerRoute || isTeilnehmerRequest) && !window.location.pathname.includes('/login')) {
        localStorage.removeItem('teilnehmer_token');
        window.location.href = '/teilnehmer/login';
      }
    }
    return Promise.reject(error);
  }
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Navigate to="/teilnehmer/login" />} />
          <Route path="/teilnehmer/login" element={<TeilnehmerLogin />} />
          <Route path="/teilnehmer/dashboard" element={<TeilnehmerDashboard />} />
          
          {/* Admin Login (No Layout) */}
          <Route path="/admin" element={<Navigate to="/admin/login" />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/setup" element={<AdminSetup />} />
          
          {/* Admin Routes (With Layout) */}
          <Route path="/admin/dashboard" element={<AdminLayout><AdminDashboard /></AdminLayout>} />
          <Route path="/admin/teilnehmer" element={<AdminLayout><TeilnehmerTab /></AdminLayout>} />
          
          {/* Kursverwaltung */}
          <Route path="/admin/kursdetails" element={<AdminLayout><KursdetailsPage /></AdminLayout>} />
          <Route path="/admin/textbausteine" element={<AdminLayout><TextbausteineTab /></AdminLayout>} />
          
          {/* Einstellungen */}
          <Route path="/admin/einstellungen" element={<Navigate to="/admin/einstellungen/system" />} />
          <Route path="/admin/einstellungen/system" element={<AdminLayout><SystemPage /></AdminLayout>} />
          <Route path="/admin/einstellungen/feldmapping" element={<AdminLayout><FeldmappingPage /></AdminLayout>} />
          <Route path="/admin/einstellungen/texte" element={<AdminLayout><TextePage /></AdminLayout>} />
          <Route path="/admin/einstellungen/kursfarben" element={<AdminLayout><KursfarbenPage /></AdminLayout>} />
          <Route path="/admin/einstellungen/benutzer" element={<AdminLayout><BenutzerPage /></AdminLayout>} />
          <Route path="/admin/einstellungen/passwort" element={<AdminLayout><PasswortPage /></AdminLayout>} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
